import { useState, useEffect } from 'react';

/**
 * Hook para detectar a presença do teclado virtual (soft keyboard) em dispositivos móveis.
 * Aplica a tolerância de 150px para evitar disparos falsos causados pelo recolhimento
 * normal da barra de endereços do navegador mobile durante a rolagem.
 */
export function useVirtualKeyboard() {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.visualViewport) return;

    const handleResize = () => {
      if (!window.visualViewport) return;
      // Tolerância estrita de 150px para ignorar resize da barra de navegação/URL do browser
      const viewportDifference = window.innerHeight - window.visualViewport.height;
      const keyboardActive = viewportDifference > 150;
      setIsKeyboardOpen(keyboardActive);
    };

    window.visualViewport.addEventListener('resize', handleResize);
    window.visualViewport.addEventListener('scroll', handleResize);

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
      window.visualViewport?.removeEventListener('scroll', handleResize);
    };
  }, []);

  return { isKeyboardOpen };
}
